import { IGeneralSettingsCache } from 'external-services/general-settings-service/types';
import {DiaryMobileVersion, loadStatus} from 'shared-types/index';
import {MainViewType} from "app/services/mainViewVisibility/types";
import {UserPointerType} from "external-services/pointer-detection-service/types";

export enum FloorPlanState {
  NOT_INITIALISED = 'NOT_INITIALISED', // DEFAULT STATE
  INITIALISED = 'INITIALISED',
  RESUMED = 'RESUMED',
  STOPPED = 'STOPPED',
  DESTROYED = 'DESTROYED',
}

export interface ISettingState {
  generalSettings: IGeneralSettingsCache;
  isManager: boolean;
  maxBookingSize: number;
  appVersion: string;
  appLoadState: loadStatus;
  mobileVersion: DiaryMobileVersion;
  floorplanState: FloorPlanState;
  bookingView: MainViewType;
  currentPointerDevice: UserPointerType;
}
